/* tslint:disabled */
/* eslint-disable */
/**
 * Alerts
 * The service provides RESTful API for manipulating alerts (CRUD)
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  AlertSeverityEnum,
  AlertSeverityEnumFromJSON,
  AlertSeverityEnumToJSON,
  AlertStatusEnum,
  AlertStatusEnumFromJSON,
  AlertStatusEnumToJSON,
  ReferenceTypeEnum,
  ReferenceTypeEnumFromJSON,
  ReferenceTypeEnumToJSON
} from './'

/**
 *
 * @export
 * @interface Alert
 */
export interface Alert {
  /**
   *
   * @type {string}
   * @memberof Alert
   */
  id?: string
  /**
   *
   * @type {string}
   * @memberof Alert
   */
  referenceId?: string
  /**
   *
   * @type {ReferenceTypeEnum}
   * @memberof Alert
   */
  referenceType?: ReferenceTypeEnum
  /**
   *
   * @type {AlertStatusEnum}
   * @memberof Alert
   */
  status?: AlertStatusEnum
  /**
   *
   * @type {AlertSeverityEnum}
   * @memberof Alert
   */
  severity?: AlertSeverityEnum
  /**
   *
   * @type {string}
   * @memberof Alert
   */
  objectURI?: string
  /**
   *
   * @type {string}
   * @memberof Alert
   */
  accountId?: string
  /**
   *
   * @type {string}
   * @memberof Alert
   */
  region?: string
  /**
   *
   * @type {string}
   * @memberof Alert
   */
  objectName?: string
  /**
   *
   * @type {string}
   * @memberof Alert
   */
  createdTime?: string
  /**
   *
   * @type {string}
   * @memberof Alert
   */
  dismissedTime?: string
  /**
   *
   * @type {string}
   * @memberof Alert
   */
  dismissedBy?: string
}

export function AlertFromJSON(json: any): Alert {
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    referenceId: !exists(json, 'referenceId') ? undefined : json['referenceId'],
    referenceType: !exists(json, 'referenceType')
      ? undefined
      : ReferenceTypeEnumFromJSON(json['referenceType']),
    status: !exists(json, 'status')
      ? undefined
      : AlertStatusEnumFromJSON(json['status']),
    severity: !exists(json, 'severity')
      ? undefined
      : AlertSeverityEnumFromJSON(json['severity']),
    objectURI: !exists(json, 'objectURI') ? undefined : json['objectURI'],
    accountId: !exists(json, 'accountId') ? undefined : json['accountId'],
    region: !exists(json, 'region') ? undefined : json['region'],
    objectName: !exists(json, 'objectName') ? undefined : json['objectName'],
    createdTime: !exists(json, 'createdTime') ? undefined : json['createdTime'],
    dismissedTime: !exists(json, 'dismissedTime')
      ? undefined
      : json['dismissedTime'],
    dismissedBy: !exists(json, 'dismissedBy') ? undefined : json['dismissedBy']
  }
}

export function AlertToJSON(value?: Alert): any {
  if (value === undefined) {
    return undefined
  }
  return {
    id: value.id,
    referenceId: value.referenceId,
    referenceType: ReferenceTypeEnumToJSON(value.referenceType),
    status: AlertStatusEnumToJSON(value.status),
    severity: AlertSeverityEnumToJSON(value.severity),
    objectURI: value.objectURI,
    accountId: value.accountId,
    region: value.region,
    objectName: value.objectName,
    createdTime: value.createdTime,
    dismissedTime: value.dismissedTime,
    dismissedBy: value.dismissedBy
  }
}
